import React from 'react';
import ImageIcon from './ImageIcon';

export default function Bloom() {
  return (
    <ImageIcon small src="/bloom.png" />
  );
}